import script from "./m-home-snippets.vue?vue&type=script&setup=true&lang=js"
export * from "./m-home-snippets.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__